import React from 'react';
import { reduxForm, Field } from 'redux-form';

//Components
import renderField from './../renderFields/renderField';

//Utils
import Validators from './../renderFields/validatorsFields';

const validate = values => {
  const errors = {};

  if (values.claveNueva && values.claveNuevaConfirm
    && (values.claveNueva !== values.claveNuevaConfirm)) {

    errors.claveNueva = 'Las contraseñas deben coincidir';
    errors.claveNuevaConfirm = 'Las contraseñas deben coincidir';
  }

  return errors;
};

const ChangePasswordForm = ({
  handleSubmit,
  onDelete,
  pristine,
  reset,
  submitting,
  loadingForm,
  readOnly
}) => {
  return (
    <form onSubmit={handleSubmit}>

      <Field
        name="claveactual"
        id="changePass-claveactual"
        type="password"
        icon="flaticon-locked"
        label="Antigua Contraseña"
        component={renderField}
        validate={[Validators.required]}
        readOnly={readOnly}
      />

      <Field
        name="claveNueva"
        id="changePass-claveNueva"
        type="password"
        icon="flaticon-locked"
        label="Nueva Contraseña"
        component={renderField}
        validate={[Validators.required, Validators.minLength8, Validators.maxLength15, Validators.validPassword]}
        readOnly={readOnly}
      />

      <Field
        name="claveNuevaConfirm"
        id="changePass-claveNuevaConfirm"
        type="password"
        icon="flaticon-locked"
        label="Repetir Nueva Contraseña"
        component={renderField}
        validate={[Validators.required, Validators.minLength6, Validators.maxLength15]}
        readOnly={readOnly}
      />

      <button
        type="submit"
        className="btn btn-primary mb-5"
        disabled={loadingForm}
      >
        Solicitar Cambio
        {loadingForm && <i className="fa fa-spinner fa-pulse ml-2 d-inline-block" />}
      </button>
    </form>
  );
};

export default reduxForm({ form: 'ChangePasswordForm', validate})(ChangePasswordForm);
